import React__default from 'react';
import { Shape } from '../Shape/index.es.js';
import { Body, Caption } from '../Typography/index.es.js';
import { Flex } from '../Flex/Flex.es.js';

const Stepper = ({ steps, active }) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, steps.map((step) => {
    const isLast = step.index === steps.length - 1;
    const isActive = step.index === active;
    return /* @__PURE__ */ React__default.createElement(Flex, {
      key: step.index,
      direction: "row",
      justify: "start"
    }, /* @__PURE__ */ React__default.createElement(Flex, {
      justify: "center",
      align: "start",
      width: 9,
      paddingTop: "s4",
      style: {
        position: "relative",
        alignSelf: "stretch"
      }
    }, /* @__PURE__ */ React__default.createElement(Shape, {
      backgroundColor: isActive ? "link" : "border",
      width: isActive ? 9 : 7,
      height: isActive ? 9 : 7,
      borderStyle: "solid",
      borderWeight: "l",
      borderColor: isActive ? "link200" : "border",
      style: { borderRadius: "50%", display: "inline-block" }
    }), /* @__PURE__ */ React__default.createElement(Shape, {
      height: "calc(100% - 9px)",
      borderStyle: "solid",
      borderWeight: "m",
      borderRight: "0px",
      borderColor: "border",
      style: {
        visibility: steps.length > 1 && isLast ? "hidden" : "visible",
        position: "absolute",
        top: "13px",
        left: "4px"
      }
    })), /* @__PURE__ */ React__default.createElement(Shape, {
      padding: ["s0", "s8"],
      paddingBottom: isLast ? "s0" : "s16"
    }, /* @__PURE__ */ React__default.createElement(Shape, {
      marginBottom: "s4"
    }, /* @__PURE__ */ React__default.createElement(Body, {
      color: isActive ? "link" : "black"
    }, step.title)), /* @__PURE__ */ React__default.createElement(Caption, {
      color: "neutral",
      weight: "regular"
    }, step.subTitle)));
  }));
};

export { Stepper };
